import { type Localisation } from "./en";

export const portuguese: Localisation = {
  dateFormats: {
    datePickerLocale: "pt",
    timeFormat: "HH:mm", // 14:30
    dayFormat: "do", // 12th
    dayMonthFormat: "do MMMM", // 1st April
    dayMonthYearFormat: "do MMMM yyyy", // 11th January 1988
    dayDateMonthYearFormat: "E, do MMMM yyyy", // Mon, 1st April 2024
    dayMonthYearTimeFormat: "do MMMM yyyy, HH:mm", // 11th January 1988, 14:30
  },
  App: {
    "Digital Displays": "Monitores Digitais",
    Loading: "Carregando",
    "Checking authentication": "Verificando autenticação",
    "Redirecting to login": "Redirecionando para login",
    "Sign in with Teamworks": "Faça login com o Teamworks",
    Initializing: "Inicializando",
    "Verifing authentication": "Verificando a autenticação",
    Redirecting: "Redirecionando",
    "Welcome back!": "Bem vindo de volta!",
    "Login to get started": "Faça login para começar",
  },
  AppSwitcher: {
    arms: "Compliance + Recruiting",
    hub: "Hub",
    inflcr: "Influencer",
    academics: "Academics",
    communities: "Communities",
    pulse: "Pulse",
    pathways: "Pathways",
    nutrition: "Nutrition",
    ams: "AMS",
    tv: "Digital Displays",
    trac: "Inventory Management",
    strength: "Strength + Conditioning",
    wallet: "Wallet",
    gm: "General Manager",
  },
  Layout: {
    "Checking authentication": "Verificando autenticação",
    Dashboard: "Painel",
    Configurations: "Configurações",
    Devices: "Dispositivos",
    Themes: "Temas",
    Settings: "Configurações",
    Announcements: "Anúncios",
    "Organisation settings": "Configurações da organização",
    "Teamworks Help": "Teamworks Ajuda",
    "Teamworks Apps": "Teamworks Aplicativos",
    "Privacy policy": "Política de Privacidade",
    Logout: "Sair",
    "Loading, please wait...": "Carregando, aguarde...",
    Users: "Usuários",
    "Switch organisation": "Mudar de organização",
    "Signing you out": "Desconectando você",
    "Open Menu": "Abrir Menu",
    "Close Menu": "Fechar menu",
    Playlists: "Listas de reprodução",
  },
  ConfigsScreen: {
    "{{count}} Configuration": "{{count}} Configuração",
    "{{count}} Configuration_other": "{{count}} Configurações",
    "New configuration": "Nova configuração",
    "Configurations allow you to customise the look and content of your displays.":
      "As configurações permitem que você personalize a aparência e o conteúdo dos seus monitores.",
    "Loading configurations": "Carregando configurações",
    Configurations: "Configurações",
    Name: "Nome",
    Tags: "Tags",
    Template: "Modelo",
    Theme: "Tema",
    "Device count": "Contagem de dispositivos",
    "Created at": "Criado em",
    "No configurations have been setup yet":
      "Nenhuma configuração foi definida ainda",
    "No configurations found for '{{searchText}}'":
      "Nenhuma configuração encontrada para '{{searchText}}'",
    "Displays allow you to cast scheduled events and media to any device with an internet browser":
      "Os displays permitem que você transmita eventos e mídia programados para qualquer dispositivo com um navegador de internet",
    "Create one now": "Crie um agora",
    "Create configuration": "Criar configuração",
    "Add custom videos, YouTube videos and images":
      "Adicione vídeos personalizados, vídeos e imagens do YouTube",
    "Filter calendar to present a live schedule":
      "Filtre o calendário para apresentar uma programação ao vivo",
    "Display weather for multiple locations":
      "Exibir o clima para vários locais",
    "A general overview for up to a week in advance":
      "Uma visão geral de até uma semana de antecedência",
    "Show temperature, wind and probability of precipitation":
      "Mostrar temperatura, vento e probabilidade de precipitação",
    "Cycle through important updates on cards":
      "Percorra atualizações importantes nos cartões",
    "Includes team crest, time and date":
      "Inclui escudo da equipe, hora e data",
    "Display a schedule over multiple days":
      "Exibir uma programação para vários dias",
    "Display daily schedule for different teams and groups.":
      "Exibir programação diária para diferentes equipes e grupos.",
    "Configuration deleted": "Configuração excluída",
    "Are you sure you want to delete this configuration?":
      "Tem certeza de que deseja excluir esta configuração?",
    "Delete configuration": "Excluir configuração",
    "Fetching configuration": "Buscando configuração",
    "Something went wrong": "Algo deu errado",
    "Edit configuration": "Editar configuração",
    "Includes background image from theme": "Inclui imagem de fundo do tema",
    "Last active at {{lastActiveAt}}": "Última atividade às {{lastActiveAt}}",
    "Loading screen devices": "Carregando dispositivos de tela",
    "Search configurations...": "Pesquisar configurações...",
    "Save changes": "Salvar alterações",
    "Last updated": "Última atualização",
    "Clear template": "Limpar modelo",
    "No template selected": "Nenhum modelo selecionado",
    "Display a full menu or an individual station":
      "Exibir um menu completo ou uma estação individual",
    "Optionally show images, descriptions and macros":
      "Opcionalmente mostrar imagens, descrições e macros",
    Orientation: "Orientação",
    Landscape: "Paisagem",
    Portrait: "Retrato",
    "Media stacked above schedule, optimised for portrait displays":
      "Mídia empilhada acima da programação, otimizada para ecrãs em retrato",
    "Multi day schedule laid out as horizontal rows":
      "Programação de vários dias disposta em linhas horizontais",
    "Multi row schedule optimised for portrait displays":
      "Programação de múltiplas linhas otimizada para ecrãs em retrato",
    "Display a team's published workout from Strength":
      "Mostrar o treino publicado de uma equipa a partir de Strength",
    "Show sections, exercises, sets, and metrics":
      "Mostrar secções, exercícios, séries e métricas",
  },
  DashboardScreen: { Dashboard: "Painel" },
  DevicesScreen: {
    Devices: "Dispositivos",
    Groups: "Grupos",
    "{{count}} Device": "{{count}} Dispositivo",
    "{{count}} Device_other": "{{count}} Dispositivos",
    "New device": "Novo dispositivo",
    "Devices are the physical displays you have linked to your account.":
      "Dispositivos são os monitores físicos que você vinculou à sua conta.",
    "No devices have been setup yet":
      "Nenhum dispositivo foi configurado ainda",
    "No devices found for '{{searchText}}'":
      "Nenhum dispositivo encontrado para '{{searchText}}'",
    "Device name": "Nome do dispositivo",
    Facility: "Instalação",
    Configuration: "Configuração",
    "Facility not set": "Instalação não definida",
    "Config not set": "Configuração não definida",
    "Create device": "Criar dispositivo",
    "Update device": "Atualizar dispositivo",
    "Screen device updated": "Dispositivo de tela atualizado",
    "Something went wrong": "Algo deu errado",
    "Adding new display device": "Adicionando novo dispositivo de exibição",
    addNewDeviceDescription:
      "Para adicionar um novo dispositivo, visite <0>{{url}}</0> no dispositivo que deseja vincular.",
    "You will be shown a QR code which can be scanned by your camera.":
      "Será mostrado um código QR que pode ser escaneado pela sua câmera.",
    "Start scanning": "Comece a digitalizar",
    Ok: "OK",
    "Are you sure you want to delete this device?":
      "Tem certeza de que deseja excluir este dispositivo?",
    "Delete device": "Excluir dispositivo",
    "Fetching devices": "Buscando dispositivos",
    Timezone: "Fuso horário",
    "Display name is required": "O nome de exibição é obrigatório",
    "Display name must be at least 3 characters long":
      "O nome de exibição deve ter pelo menos três caracteres",
    "Device setup successful": "Configuração do dispositivo bem-sucedida",
    "Switch organisation": "Mudar de organização",
    "Search devices...": "Pesquisar dispositivos...",
    "Device not found": "Dispositivo não encontrado",
    "It may have been deleted, or you do not have permission to view it.":
      "Pode ter sido excluído ou você não tem permissão para visualizá-lo.",
    "Loading device": "Carregando dispositivo",
    "Last updated": "Última atualização",
    "Playlist not set": "Lista de reprodução não definida",
    "Bulk actions": "Ações em massa",
    "Edit selected": "Editar selecionado",
    "Delete selected": "Excluir selecionado",
    "Delete {{count}} devices": "Excluir dispositivos {{count}}",
    "Are you sure you want to delete these devices?":
      "Tem certeza de que deseja excluir esses dispositivos?",
    "Devices deleted": "Dispositivos excluídos",
    "Screen devices updated": "Dispositivos de tela atualizados",
    "Update {{count}} devices": "Atualizar dispositivos {{count}}",
    "Device deleted": "Dispositivo excluído",
    "Select all": "Selecionar tudo",
    "Deselect all": "Desmarcar tudo",
    "Create virtual device": "Criar dispositivo virtual",
    "Virtual device URL": "URL do dispositivo virtual",
    "This URL can be used to integrate with systems that do not support our QR code setup.":
      "Esta URL pode ser usada para integrar com sistemas que não suportam a nossa configuração de código QR.",
    "Note: This URL will only be accessable from networks with an approved IP address.":
      "Nota: Este URL só será acessível a partir de redes com um endereço IP aprovado.",
    or: "ou",
    "Provides a hardcoded URL, for use with systems which do not support the QR setup":
      "Fornece uma URL codificada para uso com sistemas que não suportam a configuração de QR",
    "Manage schedule": "Gerir agenda",
    "Please correct any errors and try again":
      "Corrija os erros e tente novamente",
    "Skip interaction screen": "Ignorar ecrã de interação",
    skip_interaction_description:
      "O ecrã de interação exibe um botão que deve ser pressionado antes de qualquer conteúdo ser exibido. Isso ajuda a evitar problemas de reprodução automática em navegadores modernos, mas pode não ser necessário em alguns sistemas.",
    "Changing the device locale will update the language of screen text, date/time formatting and the unit of temperature.":
      "A alteração da localidade do dispositivo irá atualizar o idioma do texto do ecrã, a formatação da data/hora e a unidade de temperatura.",
    "The current date and time will be displayed the chosen timezone.":
      "A data e a hora atuais serão apresentadas no fuso horário escolhido.",
    "Device scale": "Escala do dispositivo",
    "Adjust the scale to make content appear larger or smaller on screen.":
      "Ajuste a escala para fazer o conteúdo aparecer maior ou menor na tela.",
  },
  DeviceModePicker: {
    "Device mode": "Modo do dispositivo",
    "Should this device display a configuration or a playlist?":
      "Este dispositivo deve exibir uma configuração ou uma lista de reprodução?",
    "Should this device display a configuration or a playlist?_other":
      "Estes dispositivos devem exibir uma configuração ou uma lista de reprodução?",
    config: "Configuração",
    playlist: "Lista de reprodução",
  },
  NotFoundScreen: {
    "Oops! You seem to be lost.": "Ops! Você parece estar perdido.",
    "Return to dashboard": "Retornar ao painel",
  },
  ThemeScreen: {
    "New theme": "Novo tema",
    "Themes allow you to customise the colours of your configurations.":
      "Os temas permitem que você personalize as cores de suas configurações.",
    Themes: "Temas",
    "You don't have any themes yet": "Você ainda não tem temas",
    "Themes allow you to customise the colours used by your templates":
      "Os temas permitem que você personalize as cores usadas pelos seus modelos",
    "Create one now": "Create one now",
    "Theme name": "Nome do tema",
    "Last updated": "Última atualização",
    "Create theme": "Criar tema",
    "Update theme": "Atualizar tema",
    background: "Fundo",
    backgroundText: "Texto de fundo",
    accent: "Sotaque",
    accentText: "Texto de destaque",
    announcementBar: "Barra de anúncios",
    announcementBarText: "Texto da barra de anúncios",
    "Invalid hex code": "Código hexadecimal inválido",
    "New theme created": "Novo tema criado",
    "Theme updated": "Tema atualizado",
    "Screen theme deleted": "Tema da tela excluído",
    "Something went wrong": "Algo deu errado",
    "Are you sure you want to delete this theme?":
      "Tem certeza de que deseja excluir este tema?",
    "Delete theme": "Excluir tema",
    "Loading themes": "Carregando temas",
    "Upload logo": "Carregar logotipo",
    "Remove logo": "Remover logotipo",
    "Upload background image": "Carregar imagem de fundo",
    "Remove image": "Remover imagem",
    "Theme not found": "Tema não encontrado",
    "It may have been deleted, or you do not have permission to view it":
      "Pode ter sido excluído ou você não tem permissão para visualizá-lo",
    "Loading theme": "Carregando tema",
    "Search themes...": "Pesquisar temas...",
    "{{count}} Theme": "{{count}} Tema",
    "{{count}} Theme_other": "{{count}} Temas",
    "What's a theme?": "O que é um tema?",
    "Themes allow you to customise the appearance of your configurations":
      "Os temas permitem que você personalize a aparência de suas configurações",
    "Clicking this button will begin the process of creating a new one.":
      "Clicar neste botão iniciará o processo de criação de um novo.",
    "Give your theme a memorable name": "Dê ao seu tema um nome memorável",
    "This will help you find it later when assigning it to a configuration.":
      "Isso ajudará você a encontrá-lo mais tarde, ao atribuí-lo a uma configuração.",
    "Upload a logo (optional)": "Faça upload de um logotipo (opcional)",
    "If you do not upload a logo, a Teamworks logo will appear in its place.":
      "Se você não carregar um logotipo, um logotipo do Teamworks aparecerá em seu lugar.",
    "Upload a background image (optional)":
      "Carregue uma imagem de fundo (opcional)",
    "Some configurations make use of a background image. If an image is not uploaded, the background colour selected below will be used.":
      "Algumas configurações utilizam uma imagem de fundo. Se uma imagem não for carregada, será usada a cor de fundo selecionada abaixo.",
    "Customise the colours you want to use":
      "Personalize as cores que deseja usar",
    "The 'text' options should be a contrasting colour, to ensure it can be easily read.":
      "As opções de 'texto' devem ter uma cor contrastante, para garantir que possam ser facilmente lidas.",
    "Once you are ready, save the theme by clicking this button":
      "Quando estiver pronto, salve o tema clicando neste botão",
    "Your theme will then be available to be selected when managing a configuration.":
      "Seu tema estará então disponível para ser selecionado ao gerenciar uma configuração.",
    "Theme contrast": "Contraste do tema",
    "Some content appears in containers that are semi transparent and overlayed on your chosen background colour.":
      "Parte do conteúdo aparece em contêineres semitransparentes e sobrepostos à cor de fundo escolhida.",
    "Would you like to lighten or darken your background?":
      "Gostaria de clarear ou escurecer seu fundo?",
    Dark: "Escuro",
    Light: "Luz",
    "Theme preview": "Visualização do tema",
    Close: "Fechar",
    Preview: "Visualização",
    "No themes found for '{{searchText}}'":
      "Não foram encontrados temas para '{{searchText}}'",
    or: "ou",
    "Use organisation logo": "Usar o logotipo da organização",
    "Note: Background image will only be displayed on the 'Basic' template":
      "Nota: A imagem de fundo será exibida apenas na 'Basic' template",
    "This will be used for the main branding and the match countdown logo.":
      "Isto será usado para a marca principal e o logótipo de contagem regressiva do jogo.",
    "Upload main branding logo": "Carregar logótipo de marca principal",
    "Remove main branding logo": "Remover logótipo de marca principal",
    "If uploaded, this will override the main branding logo. Match countdowns will continue to use the logo selected above.":
      "Se carregado, isto substituirá o logótipo de marca principal. As contagens regressivas dos jogos continuarão a usar o logótipo selecionado acima.",
  },
  ScreenTemplateNames: {
    "L shape with media": "Formato L com mídia",
    "Media only": "Somente mídia",
    "Schedule only": "Somente agendamento",
    "Multi day schedule": "Programação de vários dias",
    "Multi column schedule": "Programação de múltiplas colunas",
    Basic: "Básico",
    Nutrition: "Nutrição",
    Weather: "Clima",
    "Vertical stacked": "Empilhado vertical",
    "Vertical multi day schedule": "Programação vertical de vários dias",
    "Vertical multi row schedule": "Programação vertical de múltiplas linhas",
    Strength: "Força",
    "Vertical strength": "Força vertical",
  },
  DialogProvider: {
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    Close: "Fechar",
    Ok: "OK",
    "Close without saving?": "Fechar sem salvar?",
    "Close without saving": "Fechar sem salvar",
    "Any unsaved changes will be lost":
      "Quaisquer alterações não salvas serão perdidas",
    "Back to form": "Voltar ao formulário",
  },
  ConfigurationPicker: {
    Configuration: "Configuração",
    "No configurations found for '{{searchText}}'":
      "Nenhuma configuração encontrada para '{{searchText}}'",
    "No configurations found": "Nenhuma configuração encontrada",
    "No configuration selected": "Nenhuma configuração selecionada",
    "Clear configuration": "Limpar configuração",
    "Searching configurations": "Pesquisando configurações",
  },
  ThemePicker: {
    Theme: "Tema",
    "Clear theme": "Limpar tema",
    "Screen theme": "Tema da tela",
    "No theme selected": "Nenhum tema selecionado",
    "No themes found matching '{{searchText}}'":
      "Nenhum tema encontrado correspondente a '{{searchText}}'",
    "No themes found": "Nenhum tema encontrado",
    "Loading themes...": "Carregando temas...",
  },
  MarkdownField: {
    Preview: "Visualização",
    Remove: "Remover",
    "Nothing to preview": "Nada para visualizar",
    Write: "Escrever",
  },
  ErrorScreen: {
    "Something went wrong": "Algo deu errado",
    "Sorry for the inconvenience, our engineers have been notified and will be working on a fix":
      "Desculpe pelo incômodo, nossos engenheiros foram notificados e trabalharão para resolver o problema",
    "If this issue persists, please contact Teamworks customer support":
      "Se o problema persistir, entre em contato com o suporte ao cliente do Teamworks",
    Reload: "Recarregar",
    "Customer support": "Suporte ao cliente",
  },
  OrganisationSwitcher: {
    "Fetching organisations": "Buscando organizações",
    "Select an organisation": "Selecione uma organização",
    "Switching profile": "Trocando perfil",
  },
  TimeZonePicker: {
    Timezone: "Fuso horário",
  },
  MatchesDrawer: {
    "Add match": "Adicionar correspondência",
    "Fetching event": "Buscando evento",
    "Event title": "Título do evento",
    "Starts at": "Começa às",
    "Create event": "Criar evento",
  },
  FileUploadField: {
    "Upload file": "Carregar arquivo",
    "Remove file": "Remover arquivo",
  },
  HubProfilePicker: {
    Search: "Procurar",
    "Clear search text": "Limpar texto de pesquisa",
    "Search text too short": "Texto de pesquisa muito curto",
    "Please add at least 3 characters to begin a search":
      "Adicione pelo menos 3 caracteres para iniciar uma pesquisa",
    "No calendars found": "Nenhuma agenda encontrada",
    "We couldn't find any calendars matching '{{searchText}}'":
      "Não encontramos nenhum calendário correspondente a '{{searchText}}'",
    "Search...": "Procurar...",
    "Confirm selection": "Confirmar seleção",
    Close: "Fechar",
    "Add Teamworks calendars": "Adicionar calendários Teamworks",
    "Loading profiles": "Carregando perfis",
    "Search text must have at least 3 characters":
      "O texto da pesquisa deve ter pelo menos 3 caracteres",
    "No results found": "Nenhum resultado encontrado",
    "Calendar details": "Detalhes do calendário",
    "Remove calendar": "Remover calendário",
    "Are you sure you want to remove this calendar?":
      "Tem certeza de que deseja remover esta agenda?",
    "No calendars added": "Nenhuma agenda adicionada",
    "Unknown profile": "Perfil desconhecido",
    "You don't have access to this hub profile":
      "Não tens acesso a este perfil de hub",
    "Your administrator may need to review your permission groups.":
      "O seu administrador poderá ter de rever os seus grupos de permissões.",
    "Show {{count}} more": "Mostrar mais {{count}}",
    "Error loading profiles": "Erro ao carregar perfis",
    "Please try again later": "Por favor, tente novamente mais tarde",
  },
  ScreenEventsPicker: {
    "Loading events": "Carregando eventos",
    "Event countdown": "Contagem regressiva do evento",
    "Create event": "Criar evento",
    "Update event": "Evento de atualização",
    "Event title": "Título do evento",
    "Starts at": "Começa às",
    "Add opponent badge": "Adicionar emblema do oponente",
    "Remove opponent badge": "Remover distintivo do oponente",
    "Delete event": "Excluir evento",
    "Are you sure you want to delete this event?":
      "Tem certeza de que deseja excluir este evento?",
    "Delete now": "Excluir agora",
    "Opponent badge position": "Posição do distintivo do oponente",
    "Should the opponent badge be on the left or right?":
      "O distintivo do adversário deve ficar à esquerda ou à direita?",
    "i.e are you playing home or away?":
      "ou seja, você está jogando em casa ou fora?",
    "Edit event": "Editar evento",
    "Starts at must be in the future": "A hora de início deve ser no futuro",
  },
  ScreenConfigDrawer: {
    "Disable schedule loop": "Desativar loop de agendamento",
    "Loading configuration": "Carregando configuração",
    "Number of days the schedule should span. Max 5":
      "Número de dias que a programação deve abranger. Máximo 5",
    "Number of days": "Número de dias",
    "Delete configuration": "Excluir configuração",
    "Are you sure you want to delete this configuration?":
      "Tem certeza de que deseja excluir esta configuração?",
    "Configuration deleted": "Configuração excluída",
    "Something went wrong": "Algo deu errado",
    "Save changes": "Salvar alterações",
    "Configuration updated": "Configuração atualizada",
    "Prevents the schedule from looping through pages of events. Only the first page of results will be displayed.":
      "Evita que a programação percorra páginas de eventos em loop. Apenas a primeira página de resultados será apresentada.",
    "Hide past events will be auto enabled when disable loop is enabled.":
      "Ocultar eventos passados ​​será automaticamente ativado quando o ciclo de desativação estiver ativado.",
    cards: "Cartões",
    cards_desc: "Selecione cartões para adicionar texto ou imagens",
    media: "Mídia",
    media_desc: "Selecione entre vídeos, imagens e conteúdo do YouTube",
    multi_column_schedule: "Programação de múltiplas colunas",
    multi_column_schedule_desc:
      "Selecione calendários de trabalho em equipe para exibir na tela",
    multi_day_schedule: "Programação de vários dias",
    multi_day_schedule_desc:
      "Selecione calendários de trabalho em equipe para exibir na tela",
    schedule: "Agendar",
    schedule_desc:
      "Selecione calendários de trabalho em equipe para exibir na tela",
    nutrition_menu: "Menu de nutrição",
    nutrition_menu_desc: "Selecione o menu que deseja exibir",
    nutrition_dining_station: "Estação de nutrição",
    nutrition_dining_station_desc:
      "Selecione a estação de refeições que deseja exibir",
    strength_workout: "Treino de força",
    strength_workout_desc:
      "Selecione a equipa de força e condicionamento cuja sessão será exibida",
    weather: "Clima",
    weather_desc: "Exibir o clima para vários locais",
    "%future added value": "Componente desconhecido",
    "%future added value_desc": "Componente desconhecido",
    "Configuration name": "Nome da configuração",
    "Add event countdown": "Adicionar contagem regressiva de eventos",
    "A countdown will be displayed until the event starts":
      "Uma contagem regressiva será exibida até o início do evento",
    "Not saved": "Não salvo",
    "Please fix any errors and try again":
      "Corrija quaisquer erros e tente novamente",
    "Give the configuration a name": "Dê um nome à configuração",
    "Try to give it a relevant name, to help you quickly find it":
      "Tente dar um nome relevante para ajudá-lo a encontrá-lo rapidamente",
    "Pick a theme": "Escolha um tema",
    "The theme will set colours and logo for your configuration":
      "O tema definirá cores e logotipo para sua configuração",
    "Add an event (optional)": "Adicione um evento (opcional)",
    "A countdown will be displayed on the configuration until the event starts":
      "Uma contagem regressiva será exibida na configuração até o início do evento",
    "Add a Teamworks schedule": "Adicionar uma agenda do Teamworks",
    "Upload media": "Carregar mídia",
    "Add cards (optional)": "Adicionar cartões (opcional)",
    "Add multiple Teamworks schedules":
      "Adicione vários agendamentos do Teamworks",
    "Unknown component": "Componente desconhecido",
    "Events from the selected profiles will be shown on the configuration":
      "Os eventos dos perfis selecionados serão mostrados na configuração",
    "You can upload images, videos or add YouTube videos":
      "Você pode fazer upload de imagens, vídeos ou adicionar vídeos do YouTube",
    "The configuration will rotate through the cards one at a time":
      "A configuração irá girar através dos cartões, um de cada vez",
    "Each schedule will have its own column on the configuration":
      "Cada agendamento terá sua própria coluna na configuração",
    "A multiday schedule will display the events from the selected profiles across multiple days":
      "Uma programação de vários dias exibirá os eventos dos perfis selecionados em vários dias",
    "Save the configuration": "Salve a configuração",
    "Once you are happy with your updates, save the changes":
      "Quando estiver satisfeito com suas atualizações, faça o mesmo com as alterações",
    "Take a tour": "Faça um tour",
    "Remove component": "Remover componente",
    "Are you sure you want to remove this component?":
      "Tem a certeza de que deseja remover este componente?",
    "Add weather": "Adicionar tempo",
    "A weather widget will be displayed to show current weather":
      "Um widget de tempo será exibido para mostrar o tempo atual",
    "Hide past events": "Ocultar eventos passados",
    "Announcements with matching tags will be displayed on screen":
      "Os anúncios com tags correspondentes serão exibidos na tela",
    "Display weather information for multiple locations across different days":
      "Exibir informações meteorológicas para vários locais em diferentes dias",
    "Grace period (minutes)": "Período de grácia (minutos)",
    "Number of minutes to keep events on screen after they have ended":
      "Número de minutos para manter eventos na tela após o término do evento",
    "A preview of the next day's events will be displayed at the end of the schedule":
      "Uma antevisão dos eventos do dia seguinte será exibida no final da programação",
    "Show next day events": "Mostrar eventos do dia seguinte",
    "Hide schedule": "Ocultar agenda",
    "Hide the schedule component from the display":
      "Ocultar o componente de agenda do ecrã",
  },
  AnnouncementsScreen: {
    "Announcement text is required": "O texto do anúncio é obrigatório",
    "Announcements updated": "Anúncios atualizados",
    "Something went wrong": "Algo deu errado",
    "Announcements allow you to post important information to be displayed in banners across all devices.":
      "Os anúncios permitem que você publique informações importantes para serem exibidas em banners em todos os dispositivos.",
    Announcements: "Anúncios",
    "Loading announcements": "Carregando anúncios",
    "Manage announcements": "Gerenciar anúncios",
    "Announcements are displayed on all screens, at all times":
      "Os anúncios são exibidos em todas as telas, em todos os momentos",
    "No announcements yet": "Nenhum anúncio ainda",
    "New announcement": "Novo anúncio",
    "Save announcement": "Salvar anúncio",
    "Note: announcements must be a single line. New lines will be ignored.":
      "Observação: os anúncios devem ter uma única linha. Novas linhas serão ignoradas.",
    "Delete announcement": "Excluir anúncio",
    "Are you sure you want to remove this announcement?":
      "Tem certeza de que deseja remover este anúncio?",
    "{{count}} Announcement": "{{count}} Anúncio",
    "{{count}} Announcement_other": "{{count}} Anúncios",
    Content: "Contente",
    "Last updated": "Última atualização",
    "Display mode": "Modo de exibição",
    "Should the announcement be displayed on all playlists and configurations, or only on those with matching tags?":
      "O anúncio deve ser exibido em todas as listas de reprodução e configurações ou apenas naquelas com tags correspondentes?",
    "Display on all": "Exibir em todas",
    Tagged: "Marcado",
    Tags: "Tags",
    "Add start and end times": "Adicione horários de início e de fim",
    "Set the start and end time of the announcement":
      "Definir o horário de início e de fim do anúncio",
    "Starts at": "Começa em",
    "Ends at": "Termina em",
    "End time should be after the start time":
      "O horário de fim deve ser posterior ao horário de início",
    "End time cannot be in the past":
      "O horário de fim não pode estar no passado",
  },
  CardsFormField: {
    "Add card": "Adicionar cartão",
    "Add image": "Adicionar cartão",
    "Remove image": "Remover imagem",
    "Remove card": "Remover cartão",
    "Are you sure you want to remove this card?":
      "Tem certeza de que deseja remover este cartão?",
    "No cards added": "Nenhum cartão adicionado",
    "Card title": "Título do cartão",
    "Drag and drop to re-order cards":
      "Arraste e solte para reordenar os cartões",
    "Move up": "Mover para cima",
    "Move down": "Mover para baixo",
    Scheduled: "Agendado",
    "Starts at": "Começa às",
    "Ends at": "Termina às",
  },
  MediaFormField: {
    "Invalid YouTube link, please try again":
      "Link do YouTube inválido. Tente novamente",
    "File not supported, please upload an image or video":
      "Arquivo não suportado, envie uma imagem ou vídeo",
    "Upload image/video": "Carregar imagem/vídeo",
    "Add YouTube": "Adicionar YouTube",
    "Add YouTube video": "Adicionar vídeo do YouTube",
    "Video title": "Título do vídeo",
    "YouTube link": "Link do YouTube",
    Image: "Imagem",
    Video: "Video",
    YouTube: "YouTube",
    "Something went wrong, file not uploaded":
      "Algo deu errado, o arquivo não foi enviado",
    "Cancel file upload?": "Cancelar o upload do arquivo?",
    "Are you sure you want to cancel this upload?":
      "Tem certeza de que deseja cancelar este upload?",
    "Upload image": "Carregar imagem",
    "Upload video": "Enviar vídeo",
    "Uploading {{uploadPct}}%": "Carregando {{uploadPct}}%",
    "Upload complete": "Carregamento concluído",
    Name: "Nome",
    "Number seconds image displays before moving to next media item":
      "Número de segundos que a imagem é exibida antes de passar para o próximo item de mídia",
    "Duration (seconds)": "Duração (segundos)",
    "Add image": "Adicionar imagem",
    "Add video": "Adicionar vídeo",
    "Delete media": "Excluir mídia",
    "Are you sure you want to delete this media?":
      "Tem certeza de que deseja excluir esta mídia?",
    "Update duration": "Duração da atualização",
    "Edit duration": "Editar duração",
    "Remove media": "Remover mídia",
    "No media added": "Nenhuma mídia adicionada",
  },
  MultiColumnScheduleFormField: {
    "Add column": "Adicionar coluna",
    "Column title": "Título da coluna",
    "Remove column": "Remover coluna",
    "Are you sure you want to remove this column?":
      "Tem certeza de que deseja remover esta coluna?",
  },
  AuthProvider: {
    "Fetching active users": "Buscando usuários ativos",
    "Setting organisations": "Configurando organizações",
    "Logging you in": "Fazendo login",
  },
  AccessDeniedScreen: {
    "You don't have access to Digital Displays":
      "Você não tem acesso a displays digitais",
    "Please contact Teamworks customer support to request access":
      "Entre em contato com o suporte ao cliente Teamworks para solicitar acesso",
    "Sign out": "Sair",
    "Customer support": "Suporte ao cliente",
    Reload: "Recarregar",
  },
  DeviceGroupsTab: {
    "Delete group": "Excluir grupo",
    "Are you sure you want to delete this group?":
      "Tem certeza de que deseja excluir este grupo?",
    "Device group deleted successfully":
      "Grupo de dispositivos excluído com sucesso",
    "Something went wrong": "Algo deu errado",
    "Device group created successfully":
      "Grupo de dispositivos criado com sucesso",
    "Group updated": "Grupo atualizado",
    "New group": "Novo grupo",
    "Device groups allow you to group your display devices under one name.":
      "Os grupos de dispositivos permitem agrupar seus dispositivos de exibição sob um nome.",
    "Device groups": "Grupos de dispositivos",
    "{{count}} Device group": "{{count}} grupos de dispositivos",
    "{{count}} Device group_other": "{{count}} grupos de dispositivos",
    "Search groups...": "Pesquisar grupos...",
    "Group name": "Nome do grupo",
    "Device count": "Contagem de dispositivos",
    "Fetching groups": "Buscando grupos",
    "No groups": "Nenhum grupo",
    "Group name is required": "O nome do grupo é obrigatório",
    "Please select at least 2 devices":
      "Selecione pelo menos dois dispositivos",
    "Create group": "Criar grupo",
    "Update group": "Atualizar grupo",
    "Fetching devices...": "Buscando dispositivos...",
    "Select devices": "Selecione dispositivos",
    Devices: "Dispositivos",
    Groups: "Grupos",
    "Number devices": "Número de dispositivos",
  },
  ErrorState: {
    "Something went wrong": "Algo deu errado",
    "Please try again, or contact Teamworks support if the issue persists":
      "Tente novamente ou entre em contato com o suporte do Teamworks se o problema persistir",
  },
  ProductToursProvider: {
    Back: "Voltar",
    Next: "Próximo",
    Finish: "Terminar",
  },
  Drawer: {
    Close: "Fechar",
  },
  InitialSearchParamsProvider: {
    "Initializing URL params": "Inicializando parâmetros de URL",
  },
  PlaylistsScreen: {
    Playlists: "Listas de reprodução",
    "New playlist": "Nova lista de reprodução",
    "{{count}} Playlist": "{{count}} lista de reprodução",
    "{{count}} Playlist_other": "{{count}} listas de reprodução",
    Name: "Nome",
    Tags: "Tags",
    "Loading playlists": "Carregando listas de reprodução",
    "No playlists have been setup yet":
      "Nenhuma playlist foi configurada ainda",
    "Playlists allow you to join multiple configurations together.":
      "As listas de reprodução permitem que você junte várias configurações.",
    "No configurations selected": "Nenhuma configuração selecionada",
    "Add configuration": "Adicionar configuração",
    Cancel: "Cancelar",
    "Create playlist": "Criar lista de reprodução",
    "Delete playlist": "Excluir lista de reprodução",
    "Are you sure you want to delete this playlist?":
      "Tem certeza de que deseja excluir esta playlist?",
    "Loading playlist": "Carregando lista de reprodução",
    "Save changes": "Save changes",
    "Configuration already in playlist": "Configuração já na playlist",
    "The selected configuration is already part of this playlist, do you want to add it again?":
      "A configuração selecionada já faz parte desta playlist, deseja adicioná-la novamente?",
    "Remove from playlist": "Remover da lista de reprodução",
    Configuration: "Configuração",
    "Number loops": "Loops numéricos",
    Active: "Ativo",
    "Playlist updated": "Lista de reprodução atualizada",
    "Something went wrong": "Algo deu errado",
    "Last updated": "Última atualização",
    l_layout_loop_description:
      "Os itens de mídia farão um loop um determinado número de vezes antes de mudar para a próxima configuração",
    media_only_loop_description:
      "Os itens de mídia farão um loop um determinado número de vezes antes de mudar para a próxima configuração",
    basic_loop_description:
      "O agendamento irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    multi_column_schedule_loop_description:
      "O agendamento irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    multi_day_schedule_loop_description:
      "O agendamento irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    schedule_only_loop_description:
      "O agendamento irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    "%future added value_loop_description": "Tipo de configuração desconhecido",
    mvp_loop_description: "Tipo de configuração desconhecido",
    nutrition_loop_description:
      "O menu ou a estação de refeições será repetido um determinado número de vezes antes de mudar para a próxima configuração",
    weather_loop_description: "Exibir o clima para vários locais",
    vertical_stacked_loop_description:
      "Os itens de mídia farão um loop um determinado número de vezes antes de mudar para a próxima configuração",
    vertical_multi_day_schedule_loop_description:
      "O agendamento irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    vertical_multi_row_schedule_loop_description:
      "O agendamento irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    strength_loop_description:
      "A sessão irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    vertical_strength_loop_description:
      "A sessão irá repetir um determinado número de vezes antes de mudar para a próxima configuração",
    timed_description:
      "A configuração permanecerá na tela por um determinado período de tempo antes de mudar para a próxima configuração",
    Looped: "Em loop",
    Timed: "Cronometrado",
    "Duration (minutes)": "Duração (minutos)",
    "Search playlists...": "Pesquisar listas de reprodução...",
    "Edit configuration": "Editar configuração",
    "New configuration": "Nova configuração",
    "Loading configuration": "A carregar configuração",
    "Add an existing configuration to the playlist":
      "Adicionar uma configuração existente à lista de reprodução",
    "Create a new configuration to add to the playlist":
      "Criar uma nova configuração para adicionar à lista de reprodução",
    "No playlists found for '{{searchText}}'":
      "Nenhuma lista de reprodução encontrada para '{{searchText}}'",
    "Last active at {{lastActiveAt}}": "Última atividade em {{lastActiveAt}}",
    "Device count": "Contagem de dispositivos",
    "Loading screen devices": "Carregamento de dispositivos de ecrã",
    "Announcements with matching tags will be displayed on screen":
      "Os anúncios com tags correspondentes serão exibidos na tela",
  },
  PlaylistPicker: {
    Playlist: "Lista de reprodução",
    "Clear playlist": "Limpar lista de reprodução",
    "No playlist selected": "Nenhuma playlist selecionada",
    "Searching playlists": "Pesquisando listas de reprodução",
    "No playlists found for '{{searchText}}'":
      "Nenhuma playlist encontrada para '{{searchText}}'",
    "No playlists found": "Nenhuma playlist encontrada",
  },
  TableSearchField: {
    "Clear search text": "Limpar texto de pesquisa",
  },
  SettingsScreen: {
    "Organisation settings": "Configurações da organização",
    "Permission groups": "Grupos de permissões",
    "User access": "Acesso de utilizador",
    "IP Addresses": "Endereços IP",
    "Loading settings": "A carregar definições",
  },
  PermissionGroupsTab: {
    "New permission group": "Novo grupo de permissões",
    "Permission groups allow you to specify which hub profiles a user has access to when setting up a schedule":
      "Os grupos de permissões permitem que especifique a quais perfis de hub um utilizador pode aceder ao configurar um horário",
    "{{count}} Permission group": "{{count}} Grupo de permissão",
    "{{count}} Permission group_other": "{{count}} Grupos de permissões",
    "Search permission groups...": "Pesquisar grupos de permissões...",
    Name: "Nome",
    "Last updated": "Última atualização",
    "Loading permission groups": "A carregar grupos de permissões",
    "No permission groups yet": "Ainda não há grupos de permissões",
    "No permission groups found for '{{searchText}}'":
      "Nenhum grupo de permissões encontrado para '{{searchText}}'",
    "Permission groups allow you set what hub profiles a user has access to":
      "Os grupos de permissões permitem definir a quais perfis de hub um utilizador pode aceder",
    "{{count}} hub profile": "{{count}} perfil de hub",
    "{{count}} hub profile_other": "{{count}} perfis de hub",
    "Permission group created": "Grupo de permissões criado",
    "Something went wrong": "Ocorreu um erro",
    "Loading permission group": "A carregar grupo de permissões",
    "Delete permission group": "Eliminar grupo de permissões",
    "Are you sure you want to delete this permission group?":
      "Tem a certeza de que pretende eliminar este grupo de permissões?",
    "Permission group deleted": "Grupo de permissões eliminado",
    "Permission group updated": "Grupo de permissões atualizado",
    "Save changes": "Guardar alterações",
    "Permission group name": "Nome do grupo de permissões",
    "Permitted hub profiles": "Perfis de hub permitidos",
    "Only permitted profiles will appear for users to select when managing display schedules":
      "Apenas os perfis permitidos aparecerão para os utilizadores ao gerir horários de exibição",
    "Hub access": "Acesso ao Hub",
    "Nutrition access": "Acesso ao Nutrition",
    "Strength access": "Acesso ao Strength",
    Hub: "Hub",
    Nutrition: "Nutrition",
    "Accessible apps": "Aplicativos acessíveis",
  },
  UsersTab: {
    "Contact Teamworks support to add or remove users":
      "Contacte o suporte da Teamworks para adicionar ou remover utilizadores",
    "New user": "Novo utilizador",
    "This is a list of users who have access to Digital Displays":
      "Esta é uma lista de utilizadores com acesso aos Ecrãs Digitais",
    "{{count}} User": "{{count}} Usuário",
    "{{count}} User_other": "{{count}} Utilizadores",
    "Search users...": "Procurar utilizadores...",
    Name: "Nome",
    "Last updated": "Última atualização",
    "Loading users": "A carregar utilizadores",
    "Loading user": "A carregar utilizador",
    "No users yet": "Ainda não há utilizadores",
    "No users found for '{{searchText}}'":
      "Não foram encontrados utilizadores para '{{searchText}}'",
    "Super admin": "Super administrador",
    "{{count}} permission group": "{{count}} Grupo de permissão",
    "{{count}} permission group_other": "{{count}} grupos de permissões",
    "User updated": "Utilizador atualizado",
    "Something went wrong": "Algo correu mal",
    "Save changes": "Guardar alterações",
    superadmin_description:
      "Este utilizador é um super administrador. Tem acesso a todos os perfis do hub, independentemente dos grupos de permissões atribuídos.",
    admin_description:
      "Este utilizador só tem acesso aos perfis do hub atribuídos a ele através de grupos de permissões.",
    "%future added value_description": "Função desconhecida",
  },
  ManageIpAddressesTab: {
    "Edit IP addresses": "Editar endereços IP",
    "For systems which do not support our QR setup, these permitted IP addresses can be used to allow you access to hardcoded URLs. You can also enter CIDR ranges (e.g. 10.0.0.0/24).":
      "Para sistemas que não suportam a nossa configuração QR, estes endereços IP permitidos podem ser usados para permitir o acesso a URLs codificados. Também pode introduzir intervalos CIDR (p. ex., 10.0.0.0/24).",
    "{{count}} Permitted IP address": "{{count}} Endereço IP permitido",
    "{{count}} Permitted IP address_other": "{{count}} Endereços IP permitidos",
    "No IP addresses": "Nenhum endereço IP",
    "You have not added any permitted IP addresses yet":
      "Ainda não adicionou nenhum endereço IP permitido",
    "Permitted IP addresses updated": "Endereços IP permitidos atualizados",
    "Something went wrong": "Algo correu mal",
    "Save changes": "Guardar alterações",
    "No permitted IPs yet": "Ainda não há IPs permitidos",
    "Add another": "Adicionar outro",
    "IP address validation is turned off for this account. If you think this is incorrect please contact Teamworks customer support.":
      "A validação de endereço IP está desativada para esta conta. Se acha que isto está incorreto, por favor contacte o apoio ao cliente da Teamworks.",
  },
  PermissionGroupPicker: {
    "Add permission groups": "Adicionar grupos de permissões",
    "No permission groups added": "Nenhum grupo de permissões adicionado",
    "Show {{count}} more": "Mostrar {{count}} mais",
    "Clear search text": "Limpar texto de pesquisa",
    "Search permission groups...": "Pesquisar grupos de permissões...",
    "Loading permission groups": "Carregando grupos de permissões",
    "{{count}} hub profile": "{{count}} perfil hub",
    "{{count}} hub profile_other": "{{count}} perfis de hub",
    "Remove permission group": "Remover grupo de permissões",
    "No users found": "Nenhum usuário encontrado",
    "We couldn't find any users matching '{{searchText}}'":
      "Não conseguimos encontrar nenhum usuário que corresponda a '{{searchText}}'",
    "No permission groups found": "Nenhum grupo de permissões encontrado",
    "Confirm selection": "Confirmar seleção",
  },
  TableProvider: {
    "{{count}} Selected": "{{count}} Selecionado",
  },
  ComponentPicker: {
    "Pick a component": "Escolha um componente",
    media: "Mídia",
    schedule: "Agenda",
    cards: "Cartões",
    multi_day_schedule: "Agenda de vários dias",
    multi_column_schedule: "Agenda de várias colunas",
    nutrition_dining_station: "Estação de exibição de nutrição",
    nutrition_menu: "Menu de nutrição",
    strength_workout: "Treino de força",
    weather: "Clima",
    "%future added value": "Componente desconhecido",
    Add: "Adicionar",
  },
  TagPicker: {
    "Add tags": "Adicionar tags",
    Clear: "Limpar",
    "Searching tags": "A procurar tags",
    "No tags selected": "Nenhuma tag selecionada",
    "Remove tag": "Remover tag",
    "No tags found matching '{{searchText}}'":
      "Nenhuma tag encontrada correspondente a '{{searchText}}'",
    "Something went wrong": "Algo correu mal",
    "Create tag '{{tagName}}'": "Criar tag '{{tagName}}'",
    "Start typing to create a new tag":
      "Comece a digitar para criar uma nova tag",
    "Delete tag": "Excluir tag",
    "Are you sure you want to delete the tag '{{tagName}}'?":
      "Tem a certeza de que deseja excluir a tag '{{tagName}}'?",
    "Tag deleted": "Tag excluída",
  },
  DeviceScheduleScreen: {
    Devices: "Dispositivos",
    "Device schedule": "Agenda do dispositivo",
    "Schedule item created": "Item de agenda criado",
    "Something went wrong": "Algo correu mal",
    "Please correct any errors and try again":
      "Corrija os erros e tente novamente",
    "Create schedule item": "Criar item de agenda",
    "Schedule item updated": "Item de agenda atualizado",
    "Update schedule item": "Atualizar item de agenda",
    "End time should be after the start time":
      "A hora de fim deve ser depois da hora de início",
    "Schedule item cannot be in the past":
      "O item de agenda não pode estar no passado",
    "Starts at": "Começa às",
    "Ends at": "Termina às",
    "Add content": "Adicionar conteúdo",
    "Loading schedule": "A carregar agenda",
    "Delete schedule item": "Eliminar item da agenda",
    "Are you sure you want to delete this schedule item?":
      "Tem a certeza de que deseja eliminar este item da agenda?",
    "Schedule item deleted": "Item da agenda eliminado",
    "Saving this event will shorten or replace {{count}} item. Are you sure you want to continue?":
      "Guardar este evento encurtará ou substituirá {{count}} item. Tem a certeza de que deseja continuar?",
    "Saving this event will shorten or replace {{count}} item. Are you sure you want to continue?_other":
      "Guardar este evento encurtará ou substituirá {{count}} itens. Tem a certeza de que deseja continuar?",
    "Conflicts found": "Conflitos encontrados",
  },
  Calendar: {
    Previous: "Anterior",
    Today: "Hoje",
    Next: "Próximo",
    View: "Visualização",
    month: "Mês",
    week: "Semana",
    work_week: "Semana de trabalho",
    day: "Dia",
    agenda: "Agenda",
  },
  ScheduleConflictChecker: {
    "Checking for conflicts": "A verificar conflitos",
    "No conflicts found": "Não foram encontrados conflitos",
    "{{count}} conflict found": "{{count}} conflito encontrado",
    "{{count}} conflict found_other": "{{count}} conflitos encontrados",
    "Conflicts found": "Conflitos encontrados",
  },
  LocationPicker: {
    "Search locations": "Buscar locais",
    "Clear search text": "Limpar texto de busca",
    "Searching locations": "Buscando locais",
    "No results": "Nenhum resultado",
  },
  NutritionMenuField: {
    "Please select a menu": "Por favor, selecione um menu",
    "Include images": "Incluir imagens",
    "Include descriptions": "Incluir descrições",
    "Include macros": "Incluir macros",
    "Unknown menu": "Menu desconhecido",
    "Please select a dining station":
      "Por favor, selecione uma estação de refeições",
    "Unknown dining station": "Estação de refeições desconhecida",
  },
  StrengthField: {
    "Please select a team": "Selecione uma equipa",
    "Unknown team": "Equipa desconhecida",
  },
  NutritionMenuPicker: {
    "Unknown menu date": "Data do menu desconhecida",
    "Must be later than the 'after' time": "Deve ser posterior à hora 'depois'",
    "Menu date": "Data do menu",
    "Search menus": "Procurar menus",
    "Nutrition menu": "Menu de nutrição",
    "Remove menu": "Remover menu",
    "Searching menus": "A procurar menus",
    "{{count}} menu found": "{{count}} menu encontrado",
    "{{count}} menu found_other": "{{count}} menus encontrados",
    "No menus found": "Nenhum menu encontrado",
    "Try changing the date range and search again":
      "Tente alterar o intervalo de datas e procurar novamente",
    "Dining station": "Estação de refeições",
    "Loading stations": "A carregar estações",
    "Failed to fetch menus": "Falha ao buscar menus",
    "Something went wrong, please try again":
      "Algo correu mal, por favor tente novamente",
    "Failed to fetch menu dining stations":
      "Falha ao buscar as estações de refeições do menu",
  },
  StrengthTeamPicker: {
    "Strength team": "Equipa de força",
    "Loading strength teams": "A carregar equipas de força",
    "No strength teams found": "Nenhuma equipa de força encontrada",
    "Strength teams could not be loaded. Please try again.":
      "Não foi possível carregar as equipas de força. Tente novamente.",
  },
  WeatherFormField: {
    "Number of days ahead to fetch weather. Max 7":
      "Número de dias para buscar a previsão do tempo. Máximo de 7",
    "Number of days": "Número de dias",
    "Add location": "Adicionar localização",
    "Remove location": "Remover localização",
    "Are you sure you want to remove this location?":
      "Tem certeza de que deseja remover esta localização?",
    Date: "Data",
    "Default location": "Localização padrão",
    Location: "Localização",
    "Below, you can add different locations for certain dates, which will override the default location for those days.":
      "Abaixo, você pode adicionar diferentes locais para datas específicas, que substituirão o local padrão nesses dias.",
    "This is the default location for displaying weather, unless overridden by another location on a given date.":
      "Este é o local padrão para exibir o clima, a menos que seja substituído por outro local em uma data específica.",
  },
  ScreenConfigFrom: {
    "Dates must be unique": "Dates must be unique",
    "Card text must be at least 4 characters long":
      "Card text must be at least 4 characters long",
  },
  LocalePicker: {
    Locale: "Configuración regional",
    "Pick a locale": "Selecionar configuração regional",
    en: "Inglês",
    "en-US": "Inglês (EUA)",
    "en-GB": "Inglês (GB)",
    "en-CA": "Inglês (Canadá)",
    es: "Espanhol",
    "es-ES": "Espanhol (Espanha)",
    fr: "Francês",
    nl: "Holandês",
    it: "Italiano",
    de: "Alemão",
    pt: "Português (Portugal)",
    "pt-BR": "Português (Brasil)",
  },
};
